<template>
  <div id="app">
  <div class="container" >
  <img src="./assets/logo.png">
  <div transition="fadeInUpBig">
  

  <router-view/>
  <br>
  <FooterBox />
  </div>
    
  </div>
    
  </div>
</template>

<script>
import FooterBox from '@/components/Footer';
const apiUrl = 'http://survey.dev.asyncsofttech.com/';


export default {
  name: 'app',
  components : {FooterBox}
}

</script>

<style>
#app {
  text-align: center;
  
  margin-top: 50px;
}
#app img {
    margin-left:0px;
    padding:0;
  
  }
  
</style>



// WEBPACK FOOTER //
// src/App.vue